import {
  BaseTextField,
  type BaseTextFieldProps,
  type TextFieldState,
} from "./text-field";

export const formatByMask = (
  value: string,
  mask: string,
  countryCode: string,
): string => {
  const normalizedValue = value.startsWith("+") ? value : countryCode + value;
  const digitsOnly = normalizedValue.replace(/\D/g, "");
  const countryCodeDigits = countryCode.replace("+", "");
  const maxDigits = mask.split("").filter((c) => c === "#").length;
  const maxTotalDigits = countryCodeDigits.length + maxDigits;
  const limitedDigitsOnly = digitsOnly.slice(0, maxTotalDigits);

  const rawDigits = limitedDigitsOnly.startsWith(countryCodeDigits)
    ? limitedDigitsOnly.slice(countryCodeDigits.length)
    : limitedDigitsOnly;
  const limitedRawDigits = rawDigits.slice(0, maxDigits);

  let result = "";
  let digitIndex = 0;

  for (const char of mask) {
    const isDigitExpected = char === "#";
    const hasMoreDigits = digitIndex < limitedRawDigits.length;

    if (isDigitExpected) {
      if (hasMoreDigits) {
        result += limitedRawDigits[digitIndex++];
      } else {
        break;
      }
    } else {
      if (hasMoreDigits) {
        result += char;
      } else {
        break;
      }
    }
  }

  return `${result}`;
};

type PhoneFieldState = TextFieldState;

export const PhoneField = ({
  field,
  pattern,
  countryCode,
  ...props
}: BaseTextFieldProps<PhoneFieldState> & {
  pattern: string;
  unmask?: boolean;
  countryCode: string;
}) => {
  const maxDigits = pattern.split("").filter((c) => c === "#").length;
  const countryCodeDigits = countryCode.replace("+", "");
  const maxTotalDigits = countryCodeDigits.length + maxDigits;

  return (
    <BaseTextField
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      {...props}
      placeholder={pattern.replaceAll("#", "_")}
      field={{
        ...field,
        value: formatByMask(field.value, pattern, countryCode),
        onValueChanged: (input) => {
          const startsWithPlus = input.trim().startsWith("+");
          const digits = input.replace(/\D/g, "");
          const limitedDigits = digits.slice(0, maxTotalDigits);
          const finalValue = startsWithPlus
            ? `+${limitedDigits}`
            : `+${countryCodeDigits}${limitedDigits}`;
          field.onChange({ ...field, value: finalValue });
        },
      }}
    />
  );
};
